import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, Inject} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '../../../_infrastructure/TableEdit/TableEditBase';
import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { ProfessionalCategoryComponent } from './professional-category.component';

@Component({
  selector: 'work-abroad-table-edit-pm',
  templateUrl: './work-abroad-table-edit-pm.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})
export class WorkAbroadTableEditPMComponent extends TableEditBase<models.WorkAbroadPMVM> implements OnInit, OnDestroy{
  
  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];

  @Input() isSubmited = false;

  public mainSubscription: Subscription = new Subscription();
  public isCommonDataLoaded: boolean = false;

  constructor(@Inject(ProfessionalCategoryComponent) parent: Component, private modalService: ModalService,
    private commonDataService: CommonDataService) {
    super(parent, modalService);
    const domains = [
      DomainCodes.domains,
      DomainCodes.country,
      DomainCodes.yesNo
    ];

    this.mainSubscription.add(
      this.commonDataService.getDomains(domains).subscribe(
        (results: models.DomainVM[]) => {
          this.domains = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.domains).dimensions;
          this.countries = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.country).dimensions;
          this.yesNo = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.yesNo).dimensions;
          this.isCommonDataLoaded = true;
        }
      )
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
  }
}
